<template>
  <div>
    <div :style="scaleStyle" class="more-wrapper">
      <div ref="imgList" class="img-list">
        <template v-for="{ type: item } in getActivePromoList">
          <div
            v-show="isOpenMenu"
            :key="item"
            :style="item === 'achievements' ? { left: 10 + 'px' } : {}"
            class="img-item-wrapper">
            <img :src="getUrlImage(item)" alt="" class="image-icon" @click="showPromo(item)" />
            <div
              :style="item === 'achievements' ? { top: -3 + 'px', left: -2 + 'px' } : {}"
              class="img-back-icon"></div>
          </div>
        </template>
      </div>
      <div class="img-wrapper">
        <div ref="imgWrapper" class="menu_btn" @click="toggleMenu">
          <template v-if="!isOpenMenu">
            <div class="dot dot_top"></div>
            <div class="dot dot_center"></div>
            <div class="dot dot_bottom"></div>
          </template>
          <template v-if="isOpenMenu">
            <div class="cross__item cross__item_left"></div>
            <div class="cross__item cross__item_right"></div>
          </template>
        </div>
        <div ref="imageBackground" class="image-background"></div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { ACTION } from '@/store/ACTION';

export default Vue.extend({
  name: 'MoreIcons',
  data: () => ({
    isOpenMenu: false
  }),
  computed: {
    ...mapGetters(['getActivePromoList', 'getAppConfiguration', 'getIsMobile', 'getUiPosition', 'isLandscape']),
    scaleStyle(): { transform: string; top: string; left: string } {
      const addScale: number = this.getIsMobile ? 1.3 : 1;
      const topScale: number = this.getIsMobile ? 1.15 : 1;
      const top: number = this.isLandscape
        ? this.getUiPosition.landscape.menu.top
        : this.getUiPosition.portrait.menu.top;
      return {
        transform: ' translate(-50%, -50%) scale(' + this.uiScale * addScale + ')',
        top: (top / topScale) * this.uiScale + 'px',
        left: 70 * addScale * this.uiScale + 'px'
      };
    },
    uiScale(): number {
      return this.getAppConfiguration.scale;
    }
  },
  methods: {
    toggleMenu(): void {
      let [...children]: HTMLElement[] = (<any>this.$refs.imgList).children;
      if (!this.isOpenMenu) {
        this.isOpenMenu = true;
        this.$emit('toggleMenu', this.isOpenMenu);
        setTimeout(() => {
          children.map((item, index) => (item.style.top = this.getPositionTop(item, index, children) + 'px'));
          (<HTMLDivElement>this.$refs.imageBackground).style.height = this.heightMenu(children) + 'px';
        }, 0);
      } else {
        setTimeout(() => {
          this.isOpenMenu = false;
          this.$emit('toggleMenu', this.isOpenMenu);
        }, 200);
        children.map(item => (item.style.top = 0 + 'px'));
        (<HTMLDivElement>this.$refs.imageBackground).style.height = '100%';
      }
    },
    getPositionTop(item: HTMLElement, index: number, children: HTMLElement[]): number {
      // узнаем сначала позиционирование предыдущей иконки
      let topPreview: number =
        index - 1 >= 0
          ? parseFloat(children[index - 1].style.top)
          : (<HTMLElement>this.$refs.imgWrapper).offsetHeight + 30;

      // узнаем высоту предыдущей иконки
      let heightPreview: number =
        (index - 1 >= 0
          ? // @ts-ignore
            children[index - 1]?.querySelector('.image-icon').height
          : (<HTMLElement>this.$refs.imgWrapper).offsetHeight) * (index ? 1 : 0);
      return topPreview + heightPreview;
    },
    heightMenu(children: HTMLElement[]): number {
      let index: number = children.length - 1;
      let item: HTMLElement = children[index];
      // @ts-ignore
      return this.getPositionTop(item, index, children) + item.querySelector('.image-icon').height + 20;
    },
    showPromo(type: string): void {
      switch (type) {
        case 'tournament':
          promoApp.eventEmitter.emit(ACTION.SHOW_WELCOME_POPUP);
          break;
        case 'achievements':
          promoApp.eventEmitter.emit(ACTION.SHOW_WELCOME_POPUP);
          break;
      }
    },
    getUrlImage(type: string): string {
      return `${__PROMO_CONFIG.STATIC_URL}/assets/img/panel/${type}_icon.png`;
    }
  }
});
</script>

<style scoped>
.more-wrapper {
  position: fixed;
}

.img-wrapper {
  padding: 16px;
}

.img-list {
  position: relative;
}

.image-background {
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: -1;
  border-radius: 60px;
  transition: all 0.3s ease;
}

.img-item-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  transition: all 0.3s ease;
  top: 0;
}

.image-icon {
  position: relative;
  z-index: 10;
  cursor: pointer;
}

.image-icon:hover {
  transform: scale(1.05);
}

.image-icon:active {
  transform: scale(0.95);
}

.img-back-icon {
  position: absolute;
  z-index: 1;
  /*transform: scale(1.1);*/
  width: 100px;
  height: 100px;
  border-radius: 50%;
  border: 8px solid #ffffff;
  top: 5px;
}

.menu_btn {
  width: 75px;
  height: 75px;
  border: 7px solid #fff;
  border-radius: 50%;
  position: relative;
  cursor: pointer;
}

.menu_btn:hover {
  transform: scale(1.05);
}

.menu_btn:active {
  transform: scale(0.95);
}

.dot {
  position: absolute;
  left: calc(50% - 6px);
  width: 12px;
  height: 12px;
  background-color: #fff;
  border-radius: 50%;
}

.dot_top {
  top: 7px;
}

.dot_center {
  top: 26px;
}

.dot_bottom {
  bottom: 7px;
}

.cross__item {
  width: 36px;
  height: 6px;
  background-color: #ffffff;
  position: absolute;
  top: 27px;
  left: calc(50% - 17px);
}

.cross__item_left {
  transform: rotate(45deg);
}

.cross__item_right {
  transform: rotate(-45deg);
}
</style>
